import React from 'react'
import  DataExplorerSearch  from '../DataExplorerSearch'
import { Link } from 'react-router-dom'
import './index.css'


export default class DataExplorerHeaderSmall extends React.Component {
  render() {
    return (
      <div className="background-blue-map text-white">
        <div className="w-100 h-100 background-blue-map-overlay">
        <div className="cf h-container">
            <div className="fl-l w-50-l w-100 tc tl-l pa3-l pa3">
            </div>
          </div>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataExplorerHeaderSmall/index.js